import {
  Directive,
  Input,
  ElementRef,
  OnChanges,
  Renderer2,
  OnInit,
  OnDestroy,
} from "@angular/core";

@Directive({
  selector: "[appColSpan]",
  standalone: true,
})
export class ColSpanDirective implements OnChanges, OnInit, OnDestroy {
  @Input("appColSpan") colSpan: number = 1;
  private resizeListener: () => void;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.updateGridColumn();
    this.resizeListener = this.renderer.listen("window", "resize", () => {
      this.updateGridColumn();
    });
  }

  ngOnChanges() {
    this.updateGridColumn();
  }

  ngOnDestroy() {
    if (this.resizeListener) {
      this.resizeListener();
    }
  }

  private updateGridColumn() {
    const maxCols = this.getParentColumnCount();
    const effectiveColSpan = Math.min(this.colSpan, maxCols);

    this.renderer.setStyle(
      this.el.nativeElement,
      "grid-column",
      `span ${effectiveColSpan}`
    );
  }

  private getParentColumnCount(): number {
    const parent = this.el.nativeElement.parentElement as HTMLElement | null;
    if (!parent) {
      return 1;
    }

    const cssVar = getComputedStyle(parent)
      .getPropertyValue("--grid-col-count")
      .trim();
    if (cssVar) {
      const parsed = Number.parseInt(cssVar, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return window.innerWidth <= 600 ? 1 : this.colSpan;
  }
}
